import { render, staticRenderFns } from "./indexV2.vue?vue&type=template&id=78d4d6ed&"
import script from "./indexV2.vue?vue&type=script&lang=js&"
export * from "./indexV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports